import * as utils from './utils';
import i18n from '../i18n';
import {get, map} from 'lodash';
import * as Group from './group';
import moment from 'moment/moment';

export {title, columns, view, read, edit, formActions, listActions} from './membership';

export const list = utils.listFn('getCaregivers', function (payload) {
  if (get(this, 'schemaParams.group_ids')) {
    payload.group_ids = [get(this, 'schemaParams.group_ids')];
  }
  return payload;
});

export function tableFilters(schema) {
  if (this.schemaParams) {
    let self = this;
    this.$set(this.schemaParams, 'group_ids', null);
    return [
      h => h('f-select', {
        props: {
          model: this.schemaParams,
          rootModel: this.schemaParams,
          spec: {
            prop: 'group_ids',
            placeholder: i18n.fr('label_pick_a_profession'),
            type: 'select',
            search: true,
            items(value, model, fieldSpec, search) {
              return Group.list.call(self, {skip: 0, limit: 10, search})
                .then(response => {
                  return map(response.data, x => ({
                    value: x.group_id,
                    label: i18n.S(get(x, 'details.name'), get(x, 'details.name_en')),
                  }));
                });
            },
            onchange: v => {
              self.queryChanged();
            },
          },
        },
      }),
    ];
  }
  return [];
}



// WEBPACK FOOTER //
// ./src/schemas/caregiver.js